import React from 'react'
import { object } from 'prop-types'
import {
	Hits,
	SearchBox,
	Highlight,
	Pagination,
	Configure,
	Index,
} from 'react-instantsearch/dom'
import { connectStateResults } from 'react-instantsearch/connectors'
import styled, { injectGlobal } from 'react-emotion'

import {
	MAX_WIDTH,
	SPACERS,
} from 'utils/styleHelpers'

// imgs
import hero from './hero.jpg'

// overides for instantsearch default theme
// eslint-disable-next-line
injectGlobal`
	li.ais-Hits-item {
		margin-top: 1rem;
		margin-left: 1rem;
		width: calc(25% - 1rem);
		border: none;
		box-shadow: none;
	}
`

const SearchBoxWrapper = styled.div`
	background-image: url(${hero});
	background-position: center center;
	background-size: cover;
	padding: ${SPACERS.XL} ${SPACERS.L};
`

const Wrapper = styled.div`
	margin: 0 auto;
	max-width: ${MAX_WIDTH};
`

// eslint-disable-next-line
const Dispensary = ({ hit }) => (
	<div style={{ marginTop: '10px' }}>
		<span className='hit-name'>
			<Highlight attribute='name' hit={hit} />
			<div>{hit.address1}</div>
			<div>{hit.address2}</div>
			<div>{hit.city}, {hit.state} <Highlight attribute='zip' hit={hit} /></div>
		</span>
	</div>
)

// eslint-disable-next-line
const Inventory = ({ hit }) => (
	<div style={{ marginTop: '10px' }}>
		<span className='hit-name'>
			<Highlight attribute='productName' hit={hit} />
			<div>------------------</div>
			<div>{hit.dispensaryName}</div>
			<div>{hit.address1}</div>
			<div>{hit.address2}</div>
			<div>{hit.city}, {hit.state} <Highlight attribute='zip' hit={hit} /></div>
		</span>
	</div>
)

const Search = ({ searchState }) => (
	<div className='container'>
		<Configure aroundLatLngViaIP />
		<SearchBoxWrapper>
			<Wrapper>
				<SearchBox
					translations={{
						placeholder: 'Search for Dispensaries and Products near you...',
					}}
				/>
			</Wrapper>
		</SearchBoxWrapper>

		{searchState && searchState.query &&
			<Wrapper>
				<Hits hitComponent={Dispensary} />
				<Index indexName='inventory'>
					<Configure aroundLatLngViaIP />
					<Hits hitComponent={Inventory} />
				</Index>
				<Pagination />
			</Wrapper>
		}
	</div>
)

Search.propTypes = {
	searchState: object.isRequired,
}

export default connectStateResults(Search)



// WEBPACK FOOTER //
// ./src/components/Search/index.js